<template>
    <v-dialog v-model="dialog" width="1280px" max-width="85%">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" text> 수정 </v-btn>
        </template>
        <v-card>
            <v-card-title class="py-2 px-4 py-md-3 px-md-5 text-md-16 grey lighten-2">
                답글수정
                <v-spacer />
                <v-icon @click="dialog = false"> mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="py-2 px-4 py-md-3 px-md-5">
                <v-row class="row--small">
                    <v-col cols="12" md="10">
                        <v-textarea v-model="content" outlined hide-details dense />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-row class="row--small ma-n1 ma-md-0 h-100">
                            <!-- <v-col cols="12">
                                <v-file-btn block outlined color="gray-9" @input="pushFile" class="h-100">첨부</v-file-btn>
                            </v-col> -->
                            <v-col cols="12">
                                <v-btn block color="primary" @click="save" class="h-100 h-md-36">수정</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <!-- <v-row v-if="files.length">
                    <v-col class="pt-0">
                        <v-chip-group v-model="files" multiple column>
                            <v-chip color="secondary" outlined close v-for="file in files" :key="file" :value="file">{{ file.name }}</v-chip>
                        </v-chip-group>
                    </v-col>
                </v-row> -->
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
// import vFileBtn from "@/components/plugins/vuetify/v-file-btn.vue";
export default {
    // components: { vFileBtn },
    props: ["value", "comment"],
    data() {
        return {
            dialog: false,
            content: this.response?.content || "",
            // files: [],
        };
    },
    methods: {
        // pushFile(file) {
        //     this.files.push(file);
        // },
        async save() {
            try {
                const {
                    comment: { _id, _response },
                    content,
                    value,
                } = this;
                const { counselComment } = await api.v1.counsels.comments.put({ _id, content });

                const responses = [...value.responses];
                const response = responses.find(({ _id }) => _id == _response);
                const index = response.comments.findIndex((comment) => comment._id == _id);
                Object.assignDefined(response.comments[index], counselComment);
                this.$emit("input", {
                    ...value,
                    responses,
                });
                alert("수정되었습니다.");
                this.dialog = false;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        dialog() {
            if (this.dialog) this.content = this.comment.content;
        },
    },
};
</script>

<style></style>
